import Swiper from 'swiper/bundle';

/**
 * スライダー管理
 */
export default class SliderManager {
  // Swiperのインスタンスを格納する配列
  homeSliderName = 'homeSlider';

  swiperInstances = {
    homeSliderName: null,
  };

  constructor() {
    if (document.querySelector('.swiper') === null) return;

    if (window.matchMedia('(max-width: 1120px)').matches) {
      this.swiperInstances[this.homeSliderName] = new Swiper('.swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }


    // ウィンドウ変化を検知し、1121px以上の場合はhomeSliderを破棄する
    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 1121px)').matches) {
        if (this.swiperInstances[this.homeSliderName] === null) return;
        if (this.swiperInstances[this.homeSliderName].destroyed === undefined) return;

        this.swiperInstances[this.homeSliderName].destroy();
        this.swiperInstances[this.homeSliderName] = null;

      } else {
        if (this.swiperInstances[this.homeSliderName] === null) {
          this.swiperInstances[this.homeSliderName] = new Swiper('.swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          });
        }
      }
    });
  }
}
